import { useSearchParams } from "react-router-dom";
import Home from "@/pages/home/page";
import ParkingAdminPage from "@/pages/parking-admin/page";

export default function RootEntry() {
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.has("kanri");

  if (isAdmin) {
    return <ParkingAdminPage />;
  }

  return <Home />;
}